import * as R from "ramda";

interface CallWithAttributes {
  overall_score?: number;
  attributes?: {
    [key: string]: number | undefined;
  };
}

/**
 * Generates trend data for performance table visualization
 * @param calls Array of calls with attributes and overall scores
 * @returns Object with trend data for each attribute including Overall Score
 */
export const generateTrends = (calls: CallWithAttributes[]): Record<string, number[][]> => {
  if (calls.length === 0) {
    return {};
  }

  // Get all unique attribute names
  const allAttributes = R.uniq(
    R.flatten(
      calls.map(call => Object.keys(call.attributes || {}))
    )
  );

  // For each attribute, collect scores from all calls
  const trends: Record<string, number[][]> = {};

  // Add Overall Score trend
  trends["Overall Score"] = [
    calls.map(call => call.overall_score || 0)
  ];

  allAttributes.forEach(attr => {
    // Get scores for this attribute from each call
    trends[attr] = [
      calls.map(call => call.attributes?.[attr] || 0)
    ];
  });

  return trends;
};
